<template>
  <div class="w-100">

    <!-- LOGIN INVITATION -->
    <div class="p-3 border-semi-grey rounded-6 position-relative mb-5" v-if="!isLoggedIn">
      <div class="w-100 z-index-1029 position-relative">
        <div class="row no-gutters">
          <div class="col-xl-1 col-lg-2 col-md-1 col-sm-2 col-3 align-self-center">
            <svg width="50" height="48" viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.7197 23.4622C26.0828 23.4622 30.6089 18.7115 30.6089 12.57C30.6089 6.5416 26.0494 1.95416 20.7197 1.95416C15.39 1.95416 10.8305 6.62643 10.8349 12.6146C10.8394 18.7115 15.3812 23.4622 20.7197 23.4622ZM4.40358 46.2676H36.5789C36.3024 45.675 36.1641 45.042 36.1641 44.3688V35.3786C34.8003 34.2997 33.7874 32.8695 33.1942 31.2659C29.9529 29.2092 25.7191 27.8148 20.7197 27.8148C8.00167 27.8148 0 36.4888 0 42.7956C0 44.9625 1.64828 46.2676 4.40358 46.2676Z"
                class="fill-primary" />
              <path
                d="M42.4595 18.5428C38.2325 18.5428 34.8879 21.9119 34.8879 26.07C34.8879 29.2144 36.74 31.9443 39.573 33.1029V44.3688C39.573 44.7026 39.7332 44.965 39.9646 45.2233L41.9566 47.2001C42.2302 47.4603 42.6615 47.4894 42.9929 47.1825L46.6416 43.5137C46.9774 43.1936 46.9642 42.7602 46.6326 42.4445L44.5138 40.2877L47.5221 37.3598C47.8133 37.0485 47.7976 36.6019 47.4819 36.2461L44.5868 33.3466C48.0446 31.8738 49.9998 29.2527 49.9998 26.07C49.9998 21.9119 46.6308 18.5428 42.4595 18.5428ZM42.4394 22.2234C43.6853 22.2234 44.7149 23.2685 44.7149 24.4987C44.7149 25.8048 43.6853 26.8342 42.4394 26.8342C41.1824 26.8342 40.1284 25.8048 40.1284 24.4987C40.1284 23.2685 41.1579 22.2234 42.4394 22.2234Z"
                class="fill-primary" />
            </svg>
          </div>
          <div class="col-xl-9 col-lg-10 col-md-9 col-sm-10 col-9 align-self-center">
            <div class="pl-3" :class="windowWidth >= 1200 ? 'w-85' : 'w-100'">
              <p class="mb-1" :class="{
                'body-1-4': windowWidth >= 576,
                'body-2-4': windowWidth < 576
              }">Unlock More Benefits with an Account</p>
              <p class="mb-0" :class="{
                'body-2-2': windowWidth >= 576,
                'body-3-3': windowWidth < 576
              }">Enjoy Faster Transactions and Easy Order History Access</p>
            </div>
          </div>
          <div class="col-xl-2 col-lg-12 col-md-2 mt-xl-0 mt-lg-3 mt-md-0 mt-3 align-self-center">
            <div class="row slim-grid-row">
              <div class="col-xl-12 col-lg-6 col-md-12 col-6">
                <button class="g-btn g-btn-primary g-btn-md w-100 mb-2"
                  @click="goToAuthPage()">Login</button>
              </div>
              <div class="col-xl-12 col-lg-6 col-md-12 col-6">
                <button class="g-btn g-btn-secondary g-btn-md w-100"
                  @click="goToAuthPage('Register')">Register</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="z-index-1028 position-absolute w-100 h-100 bg-green radius-12"
        style="top:0;left:0;opacity:0.02"></div>
    </div>

    <!-- FORM -->
    <div class="w-100">
      <!-- FULL NAME -->
      <div class="row slim-grid-row mb-4">
        
        <!-- FIRST NAME -->
        <div class="col-6">
          <div class="w-100">
            <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.first-name')}} <span class="font-weight-bold text-danger">*</span></label>
            <input 
              type="text" 
              @input="saveContactToVuex('first_name')" 
              :disabled="disabledForm"
              class="p-3 body-2-1 w-100 border-form radius-6" 
              :class="{'border-danger': errorForm.first_name != ''}"
              placeholder="Jhon" 
              v-model="form.first_name" >
            <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="errorForm.first_name != ''">{{ errorForm.first_name }}</p>
          </div>
        </div>

        <!-- LAST NAME -->
        <div class="col-6">
          <div class="w-100">
            <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.last-name')}}</label>
            <input type="text" @input="saveContactToVuex('last_name')" :disabled="disabledForm" class="p-3 body-2-1 w-100 border-form radius-6" v-model="form.last_name" >
          </div>
        </div>
      </div>
      
      <!-- EMAIL & PHONE NUMBER -->
      <div class="row slim-grid-row mb-4">
        <!-- EMAIL -->
        <div class="col-xl-6 col-12 mb-xl-0 mb-4">
          <div class="w-100">
            <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.email')}} <span class="font-weight-bold text-danger">*</span></label>
            <div class="position-relative">
              <input 
              type="text" 
              @input="saveContactToVuex('email')" 
              :disabled="disabledForm"
              class="p-3 body-2-1 w-100 border-form radius-6" 
              :class="{'border-danger': errorForm.email != ''}"
              placeholder="email@example.com" 
              v-model="form.email" >
              <div class="position-absolute" style="top:12px;right:16px;">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="local_post_office_24px">
                  <path id="icon/maps/local_post_office_24px" fill-rule="evenodd" clip-rule="evenodd" d="M22 6C22 4.90002 21.1 4 20 4H4C2.90002 4 2 4.90002 2 6V18C2 19.1 2.90002 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM12 13L4 8V18H20V8L12 13Z" fill="black" fill-opacity="0.54"/>
                  </g>
                </svg>
              </div>
            </div>
            <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="errorForm.email != ''">{{ errorForm.email }}</p>
          </div>
        </div>

        <!-- PHONE -->
        <div class="col-xl-6 col-lg-12">
          <div class="w-100">
            <label class="body-2 mb-1 d-block">{{$t('hotel.visitor-detail.phone-number')}} <span class="font-weight-bold text-danger">*</span></label>
            <div class="position-relative w-100 border-form radius-6" :class="{'border-danger': errorForm.phone_number != ''}">
              <div class="row no-gutters">
                <div class="col-4 col-lg-5 col-xl-4 align-self-center">
                  <div class="pr-4 border-r-form" style="padding-block: 4px;" >
                    <v-select
                      :key="formKey.phone"
                      class="border-none"
                      :clearable="false"
                      :options="dataOption.country"
                      :disabled="disabledForm"
                      @input="saveContactToVuex('dial_code')" 
                      label="label" 
                      v-model="form.dial_code">
                        <template #search="{ attributes, events }">
                          <input
                            :placeholder="form.dial_code.code ? '' : '+00'"
                            class="vs__search no-focus-border"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      
                        <template #selected-option="{ dial_code }">
                          <p class="mb-0 body-2-1">{{ dial_code }}</p>
                        </template>
                        <template v-slot:option="option">
                          <div class="d-inline-block align-middle mr-2">
                            <country-flag :country='option.code' size='small'/>
                          </div>
                          <p class="mb-0 d-inline-block align-middle body-2-1">{{`${option.code} (${option.dial_code})`}}</p>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-8 col-lg-7 col-xl-8 align-self-center">
                  <input type="number" :disabled="disabledForm" @input="saveContactToVuex('phone_number')" class="w-100 border-none no-focus-border body-2-1" placeholder="000 000 000" v-model="form.phone_number" >
                </div>
              </div>
              <div class="position-absolute" style="top:12px;right:16px;">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="phone_24px">
                    <path id="icon/communication/phone_24px" fill-rule="evenodd" clip-rule="evenodd" d="M4 3H7.5C8.04999 3 8.5 3.45001 8.5 4C8.5 5.25 8.70001 6.45001 9.07001 7.57001C9.17999 7.92001 9.09998 8.31 8.82001 8.59L6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.61 14.99 15.86 14.89 16.12 14.89C16.22 14.89 16.33 14.9 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45001 3.45001 3 4 3ZM6.54004 5C6.60004 5.89001 6.75 6.76001 6.99005 7.59L5.79004 8.79001C5.38 7.59 5.12006 6.32001 5.03003 5H6.54004ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02Z" fill="black" fill-opacity="0.54"/>
                  </g>
                </svg>
              </div>
            </div>
            <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="errorForm.phone_number != ''">{{ errorForm.phone_number }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import country from "@/data/country"
	import { parsePhoneNumber, parsePhoneNumberFromString  } from 'libphonenumber-js'
  import CountryFlag from 'vue-country-flag'
  import { validationMixin } from "vuelidate";
  const { required, email } = require("vuelidate/lib/validators");

  export default {
    props: {
      disabledForm:{
        type: Boolean,
        default: false
      }
    },
    components:{
      CountryFlag
    },
    data(){
      return{
        windowWidth: window.innerWidth,
        dataOption:{
          country: country
        },
        form:{
          first_name: '',
		      last_name: '',
		      email: '',
          dial_code: {},
		      phone_number: '',
        },
        errorForm:{
          first_name: '',
		      phone_number: '',
		      email: ''
        },
        formKey: {
          phone: 0
        }
      }
    }, 
    mixins: [validationMixin],
    validations: {
      form:{
        first_name:{
          required
        },
        email: {
          required,
          email
        },
        phone_number:{
          required
        },
      }
    },
    computed:{
      ...mapGetters([
        'isLoggedIn', 
        'getMerchant', 
        'getCurrentUser',
        'getConciergeTrxGeneral'
      ])
    },
    mounted(){
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
      this.mappingCountryData()
      this.fillGuestData()
    },
    beforeDestroy() { 
      window.removeEventListener('resize', this.onResizeWindow); 
    },
    methods:{
      ...mapMutations(['setActiveRoute', 'setConciergeTrxGeneralContact']),
      onResizeWindow(){
        this.windowWidth = window.innerWidth
      },
      goToAuthPage() {
        this.$openAuthModal({ view: 'login' })
      },
      fillGuestData(){
        if(this.isLoggedIn){
          const savedContact = this.getConciergeTrxGeneral.contactDetails
          const savedContactKeys = Object.keys(savedContact);
          let savedContactParams = []
          savedContactKeys.forEach((key,index) => {
            if(this.$isEmpty(savedContact[key])){
              savedContactParams.push({
                key: key,
                value: key === 'phone_number' ? this.getCurrentUser.phone : this.getCurrentUser[key]
              })
              
            }
            const isLast = index + 1 === savedContactKeys.length;
            if(isLast){
              if(savedContactParams.length > 0){
                this.setConciergeTrxGeneralContact(savedContactParams)
              }
              this.getDataFromVuex()
            }
          })
        }else{
          this.getDataFromVuex()
        }
      },
      getDataFromVuex(){
        this.form = Object.assign({}, this.getConciergeTrxGeneral.contactDetails)
        this.form.dial_code = {} 
        this.checkPhoneNumber()
      },
      mappingCountryData(){
        this.dataOption.country = this.dataOption.country.map(x=>{
          x.label = `${x.code}/${x.dial_code}`
          return x
        })
      },
      checkPhoneNumber(){
        let phone_number = this.getConciergeTrxGeneral.contactDetails.phone_number
        if(!(phone_number == '#' || phone_number == '' || phone_number == undefined || phone_number == null)){
          try{
            const phone_parsed = parsePhoneNumberFromString(phone_number)
            if (phone_parsed) {
              this.form.dial_code = this.dataOption.country.find(x => x.dial_code.slice(1) == phone_parsed.countryCallingCode)
              this.form.phone_number = phone_parsed.nationalNumber
            }else{
              for(let i = 0; i < this.dataOption.country.length; i++){
                let el = this.dataOption.country[i]
                let check_country = parsePhoneNumber(phone_number,el.code)
                if(check_country.isValid()){
                  this.form.dial_code = this.dataOption.country.find(x => x.code == check_country.country)
                  this.form.phone_number = check_country.nationalNumber
                  break;
                }
                if(i+1 == this.dataOption.country.length && !check_country.isValid()){
                  console.log("Invalid phone number")
                  this.setActivityTrxCustomerDetail([
                    {key: 'phone_number', value: ''}
                  ])
                  this.form.phone_number = ''
                }
              }
            }
          }catch(err){
            console.log("PHONE NUMBER ERROR :", err.message)
            this.setActivityTrxCustomerDetail([
              {key: 'phone_number', value: ''}
            ])
            this.form.phone_number = ''
          }
        }
      },
      saveContactToVuex(key){
        let params = { key, value : this.form[key] }
        if(key === 'dial_code' || key === 'phone_number'){
          params.key = 'phone_number'
          const { dial_code, phone_number } = this.form
          params.value = `${ this.$isNotEmptyV2(dial_code) ? dial_code.dial_code : '' }${phone_number}`
          this.formKey.phone++
        }
        
        this.setConciergeTrxGeneralContact([params])
      },
      resetErrorMessage(){
        this.errorForm = {
          first_name: '',
		      phone_number: '',
		      email: ''
        }
      },
      validateForm(){
        this.resetErrorMessage();
        
        const validator = this.$v.form

        this.errorForm.first_name = validator.first_name.$invalid ? this.$t('hotel.visitor-detail.first-name-warning') : "";
        this.errorForm.email = validator.email.$invalid ? this.$t('hotel.visitor-detail.email-warning') : "";

        const { dial_code, phone_number } = this.form;
        if(this.$isEmpty(dial_code)){
          this.errorForm.phone_number = this.$t('hotel.visitor-detail.country-code-warning')
        }else{
          let fullPhoneNumber = `${dial_code.code}${phone_number}`
          if(validator.phone_number.$invalid){
            this.errorForm.phone_number = this.$t('hotel.visitor-detail.phone-number-warning')
          }else if(fullPhoneNumber.length < 10){
            this.errorForm.phone_number = this.$t('hotel.visitor-detail.phone-number-invalid')
          }
        }

        const isAllFormValid = () => {
          for(let key in this.errorForm){
            if(this.errorForm.hasOwnProperty(key) && this.errorForm[key] != '') return false
          }
          return true
        }
        
        return isAllFormValid();
      }
    }
  }
</script>
<style>
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
  input[type=number]{
      -moz-appearance: textfield;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/ContactDetail.vue